import styled, { keyframes } from "styled-components";
import { Color } from "../../constants/color";
import { ZIndex } from "../../constants/z-index";
import React, { ReactNode } from "react";

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.2rem;
  background-color: rgba(255, 255, 255, 0.75);
  backdrop-filter: blur(3px);
  z-index: ${ZIndex.FEEDBACK};
`;

const Spinner = styled.div`
  width: 52px;
  height: 52px;
  border: 5px solid var(--blue100);
  border-top-color: var(--blue500);
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
`;

const Message = styled.p`
  color: ${Color.BLUE};
  font-weight: bold;
  font-size: 1rem;
  font-family: sans-serif;
`;

function Loader({ children, show }: { children?: ReactNode; show: boolean }) {
  if (!show) return null;
  return (
    <Overlay>
      <Spinner />
      {children && <Message>{children}</Message>}
    </Overlay>
  );
}

export { Loader };
